import { useNavigate } from "react-router";
import back_arrow from "../../assets/images/back_arrow.png";

export default function BackSecion(props:any) {
    const navigate = useNavigate();
  return (
    <>
      <div className="d-flex align-items-center mt-3 p-075" onClick={() => navigate(props.navigate_action)}>
        <img
          src={back_arrow}
          alt=""
          width="10px"
          height="17px"
          className="d-inline"
        />

        <h6 className="mb-0 ms-3 fw-bold admin_hdclr cursor">{props.name}</h6>
      </div>
    </>
  );
}
